import { DefaultHttpClient } from '../http/default-http-client';
import { ConsoleLogger } from '../logging/console-logger';
import { CombinedLogger } from '../logging/combined-logger';
import { ApplicationInsightsLogger } from '../logging/application-insights-logger';
import { generateRandomUUID } from '../utils/uuid';
import { ServiceFactory } from '../services/service-factory';
export class SignFlow {
    constructor(services, logger) {
        this.services = services;
        this.logger = logger;
    }
    static Create(uiFrameAdapter, options, logger = ConsoleLogger.Instance) {
        const sessionId = generateRandomUUID(false);
        const combinedLogger = new CombinedLogger([logger, new ApplicationInsightsLogger(uiFrameAdapter, sessionId)]);
        const http = new DefaultHttpClient(options.baseUrl, uiFrameAdapter, sessionId, combinedLogger);
        const serviceFactory = ServiceFactory.create(uiFrameAdapter, http, logger);
        return new SignFlow(serviceFactory, combinedLogger);
    }
    /** @internal */
    static createForTest(...params) {
        return new SignFlow(...params);
    }
    /**
     * Generates a digital signature
     *
     * @param payload - Data to be signed
     * @returns Returns a Promise that fulfills with the signature
     */
    async sign(payload, modalText) {
        try {
            this.logger.logInformation('Sign Flow: Signing payload...');
            if (!payload) {
                throw new Error('The payload must be set.');
            }
            let signature = null;
            await this.services.userKeyPromptService.promptForKeyWithRetry({ modalText }, async (signingContext) => {
                // sign payload
                signature = await this.services.cryptoService.sign(signingContext.keyPair.privateKey, payload);
            });
            if (!signature) {
                throw new Error(`Couldn't compute signature for payload.`);
            }
            return signature;
        }
        catch (ex) {
            this.logger.logError(`Sign Flow: ${ex}`);
            throw ex;
        }
    }
    /**
     * Generates a short lived access token for the endpoints, so they can query the Vault and verify the signature.
     *
     * @returns An access token for the Zero Trust backend.
     */
    async issueAccessToken() {
        return await this.services.tokenService.issueAccessToken();
    }
}
